import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styled from 'styled-components';
import type { TextBlock as TextBlockType } from '../../../types/blocks';
import { type ExtendedThemeConfig, useTheme } from '../../../theme';
import TTSButton from '../../TTSButton';
import { stripMarkdown } from '../../../helpers/textExtraction';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../../state/store';

interface TextBlockProps {
  block: TextBlockType;
  blockId: string;
}

const TextBlock = ({ block, blockId }: TextBlockProps) => {
  const theme = useTheme();
  const { demo_account: isDemoAccount } = useSelector(
    (state: RootState) => state.company.company_details
  );
  return (
    <TextContainer $theme={theme}>
      <Markdown remarkPlugins={[remarkGfm]}>{block.content}</Markdown>
      <ActionsContainer>
        {isDemoAccount && <TTSButton blockId={blockId} text={stripMarkdown(block.content)} />}
      </ActionsContainer>
    </TextContainer>
  );
};

export default TextBlock;

const TextContainer = styled.div<{ $theme: ExtendedThemeConfig }>`
  padding: 16px;
  border-radius: 8px;
  background: ${(props) =>
    props.$theme.mode === 'dark' ? props.$theme.colors.assistantBubbleBg : '#fff'};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
`;
